import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthActions } from '@domgen/dgx-fe-authentication';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SelfFixRoutes } from '@self-fix/util-models';
import { tap } from 'rxjs';

@Injectable()
export class SelfFixEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly router: Router
  ) {}

  readonly expiredSession$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.sessionExpired),
        tap(() => this.router.navigate([SelfFixRoutes.ApplianceDetails])),
        tap(() => window.location.reload())
      ),
    { dispatch: false }
  );
}
